import React from "react"
import { injectIntl } from "react-intl"
import { useSelector } from "react-redux"
import Select from "react-select"
import Toggle from "react-toggle"
import { ColorSquare } from "../../../../common/color"
import { InputBoxWithLabelAndDescription } from "../../../../common/inputs"
import IntlProps from "../../../../state/helpers/IntlProps"
import { InventoryStockDocumentDefinitionSelector } from "../../../../state/inventory"
import { DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES } from "../../../../utils/inventory"
import { STOCK_DOCUMENT_DEFINITION_DESCRIPTION_INPUTS } from "../../../../utils/inventory/utils"
import { StockDirectionPlaceholder } from "../../../components"

export const Description = injectIntl((props: IntlProps) => {
    const definition = useSelector(InventoryStockDocumentDefinitionSelector.getDefinition)

    return (
        <div>
            {STOCK_DOCUMENT_DEFINITION_DESCRIPTION_INPUTS.map(input =>
                <InputBoxWithLabelAndDescription
                    key={input}
                    name={input}
                    disabled={true}
                    label={props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES[input])}
                    description={props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES[`${input}Description`])}
                    value={definition[input]}
                />
            )}

            <div className={"col-lg-7 col-12 mb-3"}>
                <label htmlFor={"stockDirection"}>
                    {props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES["direction"])}
                </label>

                <Select
                    disabled={true}
                    value={definition.direction}
                    className={"p-0"}
                    options={[
                        {value: definition.direction, label: <StockDirectionPlaceholder direction={definition.direction}/>},
                    ]}
                />

                <small className="form-text text-muted">
                    {props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES["directionDescription"])}
                </small>
            </div>


            <div className={"pl-3 pt-2 mb-3"}>
                <label htmlFor={"requiresContact"}>
                    {props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES["requiresContact"])}
                </label>

                <div>
                    <Toggle
                        clear
                        id={"requiresContact"}
                        checked={definition.includeContact}
                        icons={false}
                        disabled={true}
                    />
                </div>

                <small className="form-text text-muted">
                    {props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES["requiresContactDescription"])}
                </small>
            </div>

            <div className={"pl-3 pt-2 mb-3"}>
                <label htmlFor={"documentColor"}>
                    {props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES["documentColor"])}
                </label>

                <ColorSquare colorCode={definition.colorCode}/>

                <small className="form-text text-muted">
                    {props.intl.formatMessage(DOCUMENT_TYPES_DESCRIPTION_TAB_MESSAGES["documentColorDescription"])}
                </small>
            </div>


        </div>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/sections/documentTypes/tabs/Description.tsx